<template>
  <div class="exam-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/examline/lineitem"
        ><div class="bread">考试大纲</div></shBreadItem
      >
    </shBread>
  </div>
  <div class="exam-item">
    <CateGory />
    <div class="exam">
      <div class="item">
        <ExamItem :examItem="examItem" />
        <div class="pagnation">
          <el-pagination
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            @size-change="changeSize"
            @current-change="currentChange"
            :current-page="currentPage"
            :page-sizes="[15, 25, 35, 40]"
            :page-size="pageSize"
            background
            layout="total,  prev, pager, next"
            :total="examCount"
          >
          </el-pagination>
        </div>
      </div>
      <div class="video">
        <VideoRecommend :VideoReCommend="VideoReCommend" />
      </div>
    </div>
  </div>
</template>

<script>
import CateGory from "./components/exam-category.vue";
import ExamItem from "./components/exam-item.vue";
import { findLineItem } from "@/api/news";
import { findVideoRandom, findVideoRecommand } from "@/api/video";
import { useRouter, useRoute } from "vue-router";
import { nextTick, ref, watch } from "vue";
import VideoRecommend from "@/components/video-recommend.vue";
export default {
  components: { CateGory, ExamItem, VideoRecommend },
  setup() {
    const route = useRoute();
    const examItem = ref([]);
    //总页数
    const examCount = ref(0);
    //当前页码
    const currentPage = ref(1);
    //每页数
    const pageSize = ref(20);

    findLineItem({
      chID: route.query.firstCate,
      coID: route.query.secondCate,
      clID: route.query.thirdCate,
      size: pageSize.value,
      page: currentPage.value,
    })
      .then((data) => {
        try {
          examItem.value = data.result;
          examCount.value = data?.resultLength[0]?.totalCount;
        } catch (error) {
          console.log(error);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    const currentChange = (page) => {
      currentPage.value = page;
      try {
        findLineItem({
          chID: route.query.firstCate,
          coID: route.query.secondCate,
          clID: route.query.thirdCate,
          size: pageSize.value,
          page: currentPage.value,
        }).then((data) => {
          examItem.value = data.result;
          examCount.value = data?.resultLength[0]?.totalCount;
        });
      } catch (error) {
        console.log(error);
      }
      //console.log(page);
    };
    const changeSize = (size) => {
      pageSize.value = size;
    };
    watch(
      () => [route.query, route.fullPath],
      (newValue, oldValue) => {
        findLineItem({
          chID: route.query.firstCate,
          coID: route.query.secondCate,
          clID: route.query.thirdCate,
          size: pageSize.value,
          page: currentPage.value,
        })
          .then((data) => {
            examItem.value = data.result;
            examCount.value = data?.resultLength[0]?.totalCount;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    );

    const VideoReCommend = ref([]);
    //监控clID并获取相应推荐
    watch(
      () => route.query.thirdCate,
      () => {
        //获取视频推荐

        if (route.query.thirdCate) {
          const clID = route.query.thirdCate?.split(",");
          findVideoRecommand(clID)
            .then((data) => {
              VideoReCommend.value = data.map((item) => {
                return {
                  chID: item.chID,
                  maID: item.maID,
                  coID: item.coID,
                  clID: item.clID,
                  leName: item.leName,
                  leImg: "/web/" + item.leImg,
                  coverImg: "/web/" + item.coverImg,
                  grade: item.grade.find((ele) => ele._id == item.gradeID),
                  id: item._id,
                };
              });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          findVideoRandom(10)
            .then((data) => {
              VideoReCommend.value = data.map((item) => {
                return {
                  chID: item.chID,
                  maID: item.maID,
                  coID: item.coID,
                  clID: item.clID,
                  leName: item.leName,
                  leImg:"/web/" + item.leImg,
                  coverImg:"/web/" + item.coverImg,
                  grade: item.grade.find((ele) => ele._id == item.gradeID),
                  id: item._id,
                };
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },
      { immediate: true }
    );
    return {
      changeSize,
      currentChange,
      examItem,
      currentPage,
      examCount,
      pageSize,
      VideoReCommend,
    };
  },
};
</script>

<style lang="less" scoped>
.exam-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.exam-item {
  width: 1240px;
  margin: 0 auto;
  .exam {
    display: flex;
    justify-content: space-between;
    .item {
      width: 850px;
      background: #fff;
      .pagnation {
        display: flex;
        justify-content: center;
        margin-top: 25px;
        margin-bottom: 25px;
      }
    }
    .video {
      width: 350px;
      background: #fff;
    }
  }
}
</style>
